<span class="form-input-date-range">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" [hidden]="noLabel" class="input-label"></label>
  <p-datepicker [(ngModel)]="value" [inputId]="id" [iconDisplay]="'input'" [showIcon]="true" (onSelect)="onInput($event)"
    [disabled]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }" [firstDayOfWeek]="firstDayOfWeek"
    [maxDate]="maxDate" [minDate]="minDate" selectionMode="range" [readonlyInput]="true" [showClear]="!!value" (onClear)="onClear()" />
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"></app-form-input-error>
</span>
  